import { render } from "./ModalUserRemove.vue?vue&type=template&id=2a4dcd14&scoped=true"
import script from "./ModalUserRemove.vue?vue&type=script&lang=js"
export * from "./ModalUserRemove.vue?vue&type=script&lang=js"

import "./ModalUserRemove.vue?vue&type=style&index=0&id=2a4dcd14&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4dcd14"]])

export default __exports__